var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { modules } from './editors/modules';
const components = {};
export const Module = {
    load: (type) => __awaiter(void 0, void 0, void 0, function* () {
        let module = components[type];
        if (module) {
            return Promise.resolve(module);
        }
        module = (yield modules[type].load());
        components[type] = module;
        return module;
    }),
    get: (type) => { var _a; return (_a = components[type]) === null || _a === void 0 ? void 0 : _a.default; },
};
